import React, { type VFC, type Dispatch, type SetStateAction } from 'react';

import { PageSegmentLoadStart } from '@confluence/browser-metrics/entry-points/PageSegmentLoadStart.ts';
import { APP_NAVIGATION_METRIC } from '@confluence/browser-metrics/entry-points/app-navigation.metric.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary.ts';

import { TopNavigation } from '../src/TopNavigation.tsx';
import type { useCustomTheme } from '../src/theme/useCustomTheme.ts';

export const TopNavigationBase: VFC<{
	defaultCollapsed: boolean;
	customTheme: ReturnType<typeof useCustomTheme>;
	isNav4CollapseReminderSpotlightActive: boolean;
	setIsNav4CollapseReminderSpotlightActive: Dispatch<SetStateAction<boolean>>;
}> = ({
	defaultCollapsed,
	customTheme,
	isNav4CollapseReminderSpotlightActive,
	setIsNav4CollapseReminderSpotlightActive,
}) => {
	return (
		<ErrorBoundary
			attribution={Attribution.DISCO}
			attributes={{
				errorBoundaryId: 'TopNavigation',
			}}
		>
			<PageSegmentLoadStart metric={APP_NAVIGATION_METRIC} />
			<TopNavigation
				defaultCollapsed={defaultCollapsed}
				customTheme={customTheme}
				isNav4CollapseReminderSpotlightActive={isNav4CollapseReminderSpotlightActive}
				setIsNav4CollapseReminderSpotlightActive={setIsNav4CollapseReminderSpotlightActive}
			/>
		</ErrorBoundary>
	);
};
